import React from "react"
import { useNavigate } from "react-router-dom"
import { Card, MissionPageContainer } from "../main_portal/components/common_components/Layout"
import { PrimaryButton } from "../main_portal/components/common_components/Buttons"

export default function NotFound() {
    const navigate = useNavigate();
    return (
        <MissionPageContainer>
            <Card>
                <div className="not-found-container">
                    <h1>404</h1>
                    <h2>Page Not Found</h2>
                    <p>That page doesn't seem to exist. </p>
                    <PrimaryButton onClick={() => navigate("/dashboard")} text="Back to Dashboard" />
                </div>
            </Card>
        </MissionPageContainer>
    )
}